import React, { useState } from "react";
import Styles from "./styles.module.scss";
import H2 from "../../../../components/typography/h2";
import H3 from "../../../../components/typography/h3";
import bannerimg from "../../../../assets/newhomepageimg/branding/bannerimg.webp";
import serviceimage1 from "../../../../assets/newhomepageimg/branding/serviceimg1.webp";
import serviceimage2 from "../../../../assets/newhomepageimg/branding/serviceimg2.webp";
import serviceimage3 from "../../../../assets/newhomepageimg/branding/serviceimg3.webp";
import serviceimage4 from "../../../../assets/newhomepageimg/branding/serviceimg4.webp";
import serviceimage5 from "../../../../assets/newhomepageimg/branding/serviceimg5.webp";
import { FaPlus, FaMinus } from "react-icons/fa";
import Processimg from "../../../../assets/newhomepageimg/branding/processimg.webp"

const Branding = () => {

 const [activeIndex, setActiveIndex] = useState<number | null>(null);
const [activeFaq, setActiveFaq] = useState<number | null>(null);

const toggleAccordion = (index: number) => {
  setActiveIndex(index === activeIndex ? null : index);
};

  const services = [
    {
      title: "Brand Consulting",
      description:
        "Develop a clear and focused brand strategy that aligns your vision with your audience and business goals.",
      image: serviceimage1,
    },
    {
      title: "Brand Identity",
      description:
        "We bring your brand to life with a distinctive look and feel that shows your values and vision.",
      image: serviceimage2,
    },
    {
      title: "Logo Design",
      description:
        "We design logos that are simple, memorable, and aligned with your brand’s personality and purpose.",
      image: serviceimage3,
    },
    {
      title: "Brand Collateral",
      description:
        "We design a full suite of branded materials that reflect your identity and ensure every customer interaction feels consistent and professional",
      image: serviceimage4,
    },
      {
      title: "Graphic Design",
      description:
        "We design visuals that not only look great but also communicate your message clearly and align with your brand identity across every platform",
      image: serviceimage5,
    },
    // {
    //   title: "Graphic Designing",
    //   description:
    //     "We help your brand stay stylish and engaging with eye-catching graphics through creative concept execution.",
    //   image: serviceimage5,
    // },
    // {
    //   title: "Posting & Scheduling",
    //   description:
    //     "We help your brand stay visible and on-time with scheduled posts and optimal timing through planning.",
    //   image: serviceimage6,
    // },
  ];

  const accordionData = [
    {
      title: "Brand Discovery",
      content:
        "We create eye-catching display ads that boost visibility and drive traffic across websites and apps. With smart targeting and compelling visuals, we help your brand stay top-of-mind.",
    },
    {
      title: "Strategy Development",
      content:
        "We craft engaging video ads that capture attention and tell your brand story. From short reels to YouTube campaigns, we help you connect with your audience through impactful visuals.",
    },
    {
      title: "Visual Identity Design",
      content: "We run targeted campaigns to drive high-quality app installs and in-app conversions. By reaching the right users at the right time, we help you grow and retain your app audience efficiently.",
    },
    {
      title: "Verbal Identity & Messaging",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
        {
      title: "Brand Collateral & Applications",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
        {
      title: "Brand Guidelines & Launch Support",
      content:
        "We design and run high-converting campaigns that boost product visibility and drive online sales. From seasonal promotions to retargeting, we help e-commerce brands grow faster.",
    },
  ];


const faqData = [
  {
    question: "How long does the branding process take?",
    answer: "Digital marketing promotes your business online using tools like social media, SEO, and email to increase visibility and sales."
  },
  {
    question: "Can I get just a logo instead of the full branding package?",
    answer: "You may start seeing early signs in 1-3 months, but significant ROI usually builds over 3–6 months."
  },
  {
    question: "Will I own the final files and designs?",
    answer: "Yes, we provide regular performance updates with key metrics and next-step recommendations."
  },
  {
    question: "Do you offer ongoing support after the branding is done?",
    answer: "We work with Instagram, Facebook, LinkedIn, Google Ads, YouTube, and more depending on your audience."
  },
];

  return (
    <>
      <div className="container">
        <div className={Styles.project_info}>
        <div className={Styles.breadcrumb}>
 <a href="/" ><span>
 Home
</span>
</a>
<span className={Styles.separator}>/</span>
 <span>
 Services
</span>
  <span className={Styles.separator}>/</span>
  <span className={Styles.active}>Branding</span>
</div>

          <div style={{ marginTop: "80px" }}>
            <H3>
              <span>We Help You Build a Brand Identity That Tells Your Story,  </span>
            
              <span>Connects with Your Audience</span>
            </H3>
          </div>
        </div>
      </div>

      <div className={Styles.bannerimg}>
        <img src={bannerimg} alt="bannerimg" />
      </div>

      <div className="container">
        <div className={Styles.strategysection}>
          <h1 className={Styles.heading}>
       Branding That Starts with Purpose and  {" "}
            <span className={Styles.highlight}>Ends with Impact</span> 
          </h1>
          <p className={Styles.description}>
          Your brand is the first impression, the lasting memory, and the story people tell when you're not in the room. It’s more than just a logo or visual identity—it’s the emotion your audience feels, the values you represent, and the way your business stands apart in a crowded market. At our core, we help businesses transform ideas into bold, consistent brand identities that speak with purpose and clarity. Through thoughtful strategy, creative design, and a deep understanding of your goals, we shape brand experiences that not only look great but also inspire trust, loyalty, and connection. Whether you're launching something new or refreshing an existing brand, we’re here to bring your vision to life—authentically, strategically, and memorably.
          </p>
          <button className={Styles.ctaButton}>Let's Talk</button>
        </div>
      </div>

      <div className={Styles.bgservices}>
        <div className="container">
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Services We Provide</p>
              <h2 className={Styles.titlegrid}>
              
            We offer everything you need to<br/>
build a  {" "}
                <span className={Styles.highlightgrid}>consistent and powerful brand</span>{" "}
                 
              </h2>
              <p className={Styles.descriptiongrid}>
              Our services are designed to cover every stage of your brand journey ensuring your
message looks and feels consistent across all touchpoints
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div
  className={`${Styles.grid} ${
    services.length === 5 ? Styles.fiveCardLayout : services.length >= 3 ? Styles.threeCols : Styles.twoCols
  }`}
>
  {services.map((service, idx) => (
    <div className={Styles.card} key={idx}>
      <img
        src={service.image}
        alt={service.title}
        className={Styles.imagegrid}
      />
      <h3 className={Styles.cardTitle}>{service.title}</h3>
      <p className={Styles.cardDescription}>{service.description}</p>
    </div>
  ))}
</div>
        </div>
      </div>

      <div className={Styles.processWrapper}>
        <div className="container">
          {/* Left Column */}
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Our Process</p>
              <h2 className={Styles.titlegrid}>
Our process is designed to build
 
              {" "}<br/>
                <span className={Styles.highlightgrid}>brands with purpose </span>{" "}
                clarity and impact
 
              </h2>
              <p className={Styles.descriptiongrid}>
            We follow a structured, end-to-end process to design, build, and launch websites and apps that are fast, scalable, and user-focused.
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div className={Styles.accordionSection}>

    <div className={Styles.accordionGrid}>
      {/* Left Side */}
      <div className={Styles.leftContent}>
        <img src={Processimg} alt="Social Media" className={Styles.accordionImage} />
        <div className={Styles.cardBoxx}>
          <p className={Styles.cardTitlee}>Want long-term traffic alongside paid results?</p>
          <p className={Styles.cardTextt}>
Our SEO helps you rank organically, so you keep getting leads even when ads pause.
          </p>
          <button className={Styles.cardButton}>Learn More</button>
        </div>
      </div>

      {/* Right Side - Accordion */}
      <div className={Styles.rightContent}>
        {accordionData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => toggleAccordion(index)}
            >
              <h4>{item.title}</h4>
              <span>
  {activeIndex === index ? (
  <FaMinus />
) : (
 <svg width="28" height="28" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.0938 23.375H20.625V29.9062C20.625 30.0953 20.7797 30.25 20.9688 30.25H23.0312C23.2203 30.25 23.375 30.0953 23.375 29.9062V23.375H29.9062C30.0953 23.375 30.25 23.2203 30.25 23.0312V20.9688C30.25 20.7797 30.0953 20.625 29.9062 20.625H23.375V14.0938C23.375 13.9047 23.2203 13.75 23.0312 13.75H20.9688C20.7797 13.75 20.625 13.9047 20.625 14.0938V20.625H14.0938C13.9047 20.625 13.75 20.7797 13.75 20.9688V23.0312C13.75 23.2203 13.9047 23.375 14.0938 23.375Z" fill="#444444"/>
<path d="M37.8125 4.8125H6.1875C5.42695 4.8125 4.8125 5.42695 4.8125 6.1875V37.8125C4.8125 38.573 5.42695 39.1875 6.1875 39.1875H37.8125C38.573 39.1875 39.1875 38.573 39.1875 37.8125V6.1875C39.1875 5.42695 38.573 4.8125 37.8125 4.8125ZM36.0938 36.0938H7.90625V7.90625H36.0938V36.0938Z" fill="#444444"/>
</svg>

)}
              </span>
            </div>
            {activeIndex === index && (
              <div className={Styles.accordionContent}>
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>



      
         
        </div>
      </div>
      <div className={Styles.ctaBannerbranding}>
  <div className={Styles.ctaOverlay}>
    <h2 className={Styles.ctaHeading}>
   Ready to build a brand that

 <br /> truly stands out?
    </h2>
    <p className={Styles.ctaSubtext}>Start your branding journey with us today</p>
    <button className={Styles.ctaButton}>Get Started Now</button>
  </div>
</div>
<div>

 
  <div className="container">
    <div className={Styles.faqGrid}>
      
      {/* Left: Title */}
      <div className={Styles.faqTitleBlock}>
        <p className={Styles.faqLabel}>F.A.Q</p>
        <h2 className={Styles.faqHeading}>
        Frequently Asked Questions<br/>
and Helpful Answers
        </h2>
      </div>

      {/* Right: Accordion */}
      <div className={Styles.faqAccordion}>
        {faqData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => setActiveFaq(index === activeFaq ? null : index)}
   
            >
              <h4>{item.question}</h4>
              <span>{activeFaq === index ? (
  <FaMinus />
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.6875 12.75H11.25V16.3125C11.25 16.4156 11.3344 16.5 11.4375 16.5H12.5625C12.6656 16.5 12.75 16.4156 12.75 16.3125V12.75H16.3125C16.4156 12.75 16.5 12.6656 16.5 12.5625V11.4375C16.5 11.3344 16.4156 11.25 16.3125 11.25H12.75V7.6875C12.75 7.58437 12.6656 7.5 12.5625 7.5H11.4375C11.3344 7.5 11.25 7.58437 11.25 7.6875V11.25H7.6875C7.58437 11.25 7.5 11.3344 7.5 11.4375V12.5625C7.5 12.6656 7.58437 12.75 7.6875 12.75Z" fill="#444444"/>
    <path d="M20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM19.6875 19.6875H4.3125V4.3125H19.6875V19.6875Z" fill="#444444"/>
  </svg>
)}</span>
            </div>
            {activeFaq === index && (
              <div className={Styles.accordionContent}>
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>


</div>
    </>
  );
};

export default Branding;